import React, { Component } from 'react'
import styled from 'styled-components'
import Loading from 'components/Loading'
import Error from 'components/Error'
import Functions from 'validations'

import mapValues from 'lodash/mapValues'
import isFunction from 'lodash/isFunction'
import first from 'lodash/first'
import last from 'lodash/last'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import isEqual from 'lodash/isEqual'
import { backgroundColors } from 'config'

export default class FormV2 extends Component {
  /**
   * Validates form fields based on flowfields sent
   * by props
   */
  isFormValid() {
    const { values, fields } = this.props
    let invalid = {}

    mapValues(fields, (validations, key) => {
      let multiple = key.indexOf(',') !== -1
      let fields = [values[key]]

      // Multiple params validation
      if (multiple) {
        let valueNames = key.split(',')
        fields = valueNames.map((name) => {
          return values[name]
        })
      }

      let validatorNameInAsValues = false
      let shouldDoTheRest = true
      const firstValidation = first(validations)
      mapValues(values, (value, valKey) => {
        if (firstValidation === valKey) {
          validatorNameInAsValues = Functions[firstValidation]
        }
      })

      // Only passs if value in Values
      if (validatorNameInAsValues !== false) {
        if (!validatorNameInAsValues(values)) {
          shouldDoTheRest = false
        } else {
          validations.shift()
        }
      }

      // Ignore all if validation matches
      if (firstValidation && firstValidation.indexOf('ignoreIf') !== -1) {
        const validation = last(firstValidation.split('.'))
        if (Functions[validation](values)) {
          shouldDoTheRest = false
        }
      }

      if (shouldDoTheRest) {
        for (var index = 0; index < validations.length; index++) {
          const validation = validations[index]
          const validator = Functions[validation]

          if (isFunction(validator)) {
            const validationResult = validator(...fields, values)
            if (isObject(validationResult)) {
              if (validationResult.flag) {
                invalid[key] = validationResult
                break
              }
            } else {
              if (validationResult) {
                invalid[key] = validation
                break
              }
            }
          }
        }
      }
    })
    return { valid: isEmpty(invalid), invalid }
  }

  /**
   * Stuff to do on first mount
   */
  componentDidMount() {
    // // Scrols to top on component mount
    // setTimeout(() => {
    //   const element = document.getElementById('anchor')
    //   if (element) {
    //     element.scroll({ top: 0, behavior: 'smooth' })
    //   }
    // }, 100)
  }

  /**
   * Refresh invalids
   */
  componentDidUpdate() {
    const currentInvalid = this.props.invalid
    const { setInvalid } = this.actions

    // Update invalids on changes
    if (!isEmpty(currentInvalid)) {
      const { valid, invalid } = this.isFormValid()

      if (!isEqual(currentInvalid, invalid)) {
        if (valid) {
          setInvalid({})
        } else {
          setInvalid(invalid)
        }
      }
    }
  }

  /**
   * Renders the top info
   */
  renderTop() {
    const { loading, error } = this.props

    if (loading) {
      return <Loading />
    }

    if (error) {
      return <Error />
    }
  }

  /**
   * Renders the buttons
   */
  renderSubmitButton(isLoading = false) {
    return (
      <ButtonWrapper id={`buttons-simulator`}>
        {this.submit && (
          <StyledButton
            bgNormalColor={backgroundColors.normalLeft}
            arrowRight
            disabled={isLoading}
            right
            strokeColor={`#FFFFFF`}
            onClick={() => {
              if (!isLoading) {
                this.submit()
              }
            }}>
            <strong>{this.state.nextText}</strong>
          </StyledButton>
        )}
      </ButtonWrapper>
    )
  }
}

const ButtonWrapper = styled.div`
  display: flex;
  padding: 24px 20px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  max-width: 1200px;
  margin-inline: auto;

  @media screen and (min-width: 1300px) {
    padding-inline: 0px;
  }
`

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 48px;
  padding: 12px;
  gap: 8px;
  background: ${({ bgNormalColor }) => bgNormalColor};
  border: none;
  outline: none;

  color: #fff;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  transition: all 0.3s ease-in-out;
  border-radius: 0px;
  cursor: pointer;

  > strong {
    margin: 0 10px;
  }

  &:hover {
    color: #ffffff;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.2) 100%
      ),
      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);
  }
`



// WEBPACK FOOTER //
// ./src/containers/FormV2/index.js